import { DISTRIBUTION_URL } from "../../../services/common-urls";
import { JSON_STRING, MHTTPCL } from "../../../services/http/http-client";

export const Shop_groupsService = {
  getShopGroups: ({ start = 0 }) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shop_groups",
      start
    }),
  addShopGruop: (shop_group_name, group_type, channel) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "add_shop_group",
      shop_group_name,
      group_type,
      channel
    }),
  fetchShopGruopDetailsTabOverview: shop_group_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shop_group_shops_tab_data",
      shop_group_id
    }),
  fetchShopGroupShopDetailsTabOverview: shop_group_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shop_group_related_shops",
      shop_group_id
    }),
  fetchShopGroupContractDetailsTabOverview: shop_group_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shop_group_related_contracts",
      shop_group_id
    }),
  removeShopGroup: shop_group_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "remove_shop_group",
      shop_group_id
    }),
  removeShopRelation: shop_relation_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "remove_shop_relation",
      shop_relation_id
    }),
  newShops: shop_group_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_unrelated_shops",
      shop_group_id
    }),
  searchShops: ({ shop_group_id, search_term }) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_unrelated_shops",
      shop_group_id,
      search_term
    }),
  makeShopsRelation: ({ shop_group_id, shop_ids }) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "make_shop_group_shops_relation",
      shop_group_id,
      shop_ids
    }),
  saveShops: shop_group_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shop_group_related_shops",
      shop_group_id
    })
};
